/* eslint-disable react/prop-types */
import React from 'react';

const InputRadio = ({
  error,
  fields,
  touched,
  required,
  groupName,
  groupLabel,
}) => (
  <>
    <div className='mb-4'>
      <div className={`${touched && error && 'input-error'} radioInput form-outline DashBoardInputBx`}>
        <label id={groupName} className='form-label' htmlFor={groupName}>
          {groupLabel}
          {required && <span className='RedStar'>*</span>}
        </label>
        <div>
          {
            fields?.map(({ name, label, value, handleBlur, checkedValue, handleChange }) => (
              <label key={name} className='me-4' htmlFor={name}>
                <input
                  id={name}
                  type='radio'
                  value={value}
                  name={groupName}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  checked={checkedValue === value}
                />
                {label}
              </label>
            ))
          }
        </div>
      </div>
      {
        touched && error && (
          <div className='text-danger'>{error}</div>
        )
      }
    </div>
  </>
);

export default InputRadio;
